<template>
  <div>
    <!-- Dashboard Layout -->
    <a-layout 
      class="layout-dashboard layout-dashboard-rtl" 
      id="layout-dashboard" 
      :class="[
        navbarFixed ? 'navbar-fixed' : '', 
        !sidebarCollapsed ? 'has-sidebar' : '', 
        layoutClass
      ]"
    >
      
      <!-- Settings Drawer -->
      <DashboardSettingsDrawer
        :showSettingsDrawer="showSettingsDrawer"
        :named="'MechTrace Dashboard RTL'"
        :navbarFixed="navbarFixed"
        :sidebarCollapsed="sidebarCollapsed"
        :rtl="true"
        @toggleSettingsDrawer="toggleSettingsDrawer"
        @toggleNavbarPosition="toggleNavbarPosition"
        @toggleSidebar="toggleSidebar"
      />
      <!-- / Settings Drawer -->
      
      <!-- Main Sidebar -->
      <DashboardSidebar
        :sidebarCollapsed="sidebarCollapsed"
        :sidebarColor="sidebarColor"
        :sidebarTheme="sidebarTheme"
        @toggleSidebar="toggleSidebar"
      />
      <!-- / Main Sidebar -->

      <!-- Layout Content -->
      <a-layout>

        <!-- Layout Header -->
        <DashboardHeader
          :sidebarCollapsed="sidebarCollapsed"
          :navbarFixed="navbarFixed"
          @toggleSettingsDrawer="toggleSettingsDrawer"
          @toggleSidebar="toggleSidebar"
        />
        <!-- / Layout Header -->

        <!-- Page Content -->
        <a-layout-content 
          class="content"
          :style="contentStyles"
        >
          <router-view />
        </a-layout-content>
        <!-- / Page Content -->

        <!-- Layout Footer -->
        <DashboardFooter />
        <!-- / Layout Footer -->

        <!-- Sidebar Overlay -->
        <div 
          class="sidebar-overlay" 
          @click="sidebarCollapsed = true" 
          v-show="!sidebarCollapsed"
        ></div>
        <!-- / Sidebar Overlay -->
          
        <!-- Floating Action Button For Settings Drawer -->
        <a-button 
          class="fab" 
          shape="circle" 
          type="primary"
          @click="showSettingsDrawer = true"
        >
          <template #icon>
            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path fill-rule="evenodd" clip-rule="evenodd" d="M11.4892 3.17094C11.1102 1.60969 8.8898 1.60969 8.51078 3.17094C8.26594 4.17949 7.11045 4.65811 6.22416 4.11809C4.85218 3.28212 3.28212 4.85218 4.11809 6.22416C4.65811 7.11045 4.17949 8.26593 3.17094 8.51078C1.60969 8.8898 1.60969 11.1102 3.17094 11.4892C4.17949 11.7341 4.65811 12.8896 4.11809 13.7758C3.28212 15.1478 4.85218 16.7179 6.22417 15.8819C7.11045 15.3419 8.26594 15.8205 8.51078 16.8291C8.8898 18.3903 11.1102 18.3903 11.4892 16.8291C11.7341 15.8205 12.8896 15.3419 13.7758 15.8819C15.1478 16.7179 16.7179 15.1478 15.8819 13.7758C15.3419 12.8896 15.8205 11.7341 16.8291 11.4892C18.3903 11.1102 18.3903 8.8898 16.8291 8.51078C15.8205 8.26593 15.3419 7.11045 15.8819 6.22416C16.7179 4.85218 15.1478 3.28212 13.7758 4.11809C12.8896 4.65811 11.7341 4.17949 11.4892 3.17094ZM10 13C11.6569 13 13 11.6569 13 10C13 8.34315 11.6569 7 10 7C8.34315 7 7 8.34315 7 10C7 11.6569 8.34315 13 10 13Z" fill="currentColor"/>
            </svg>
          </template>
        </a-button>
        <!-- / Floating Action Button -->

      </a-layout>
      <!-- / Layout Content -->

    </a-layout>
    <!-- / Dashboard Layout -->

  </div>
</template>

<script>
export default {
  mounted() {
    this.removePaddingForce()
  },
  updated() {
    this.removePaddingForce()
  },
  methods: {
    removePaddingForce() {
      this.$nextTick(() => {
        const contents = document.querySelectorAll(
          '.ant-layout-content, .content'
        )
        contents.forEach(el => {
          el.style.padding = '0'
          el.style.margin = '0'
          el.style.background = 'transparent'
        })
      })
    }
  }
}
</script>

<style scoped>

.layout-dashboard {
  min-height: 0vh;
}

.layout-dashboard-rtl {
  direction: rtl;
}

#layout-dashboard .ant-layout-content,
.layout-dashboard .ant-layout-content {
  padding: 0 !important;
  margin: 0 !important;
  background: transparent !important;
}

/* Remove all padding and margin from content */
.content {
  margin: 0 !important;
  padding: 0 !important;
  background: transparent !important;
  min-height: 280px;
  border-radius: 0;
}

/* Override any Ant Design default styles */
::v-deep .ant-layout-content {
  padding: 0 !important;
  margin: 0 !important;
  background: transparent !important;
}

/* Floating Action Button */
.fab {
  position: fixed;
  bottom: 24px;
  left: 24px;
  z-index: 999;
  width: 56px;
  height: 56px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  display: flex;
  align-items: center;
  justify-content: center;
}

.layout-dashboard-rtl .fab {
  left: auto;
  right: 24px;
}

.fab:hover {
  transform: scale(1.05);
  box-shadow: 0 6px 16px rgba(0, 0, 0, 0.2);
}

/* Sidebar Overlay */
.sidebar-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.45);
  z-index: 998;
  display: none;
}

@media (max-width: 991px) {
  .sidebar-overlay {
    display: block;
  }
}

/* Navbar Fixed */
.navbar-fixed .ant-layout-header {
  position: fixed;
  top: 0;
  left: 250px;
  right: 0;
  z-index: 10;
}

.layout-dashboard-rtl.navbar-fixed .ant-layout-header {
  left: 0;
  right: 250px;
}

.navbar-fixed .ant-layout-content {
  margin-top: 64px;
}

/* Has Sidebar - FIXED: Remove margin */
.has-sidebar .ant-layout-content {
  margin-left: 0 !important;
}

.layout-dashboard-rtl.has-sidebar .ant-layout-content {
  margin-left: 0 !important;
  margin-right: 0 !important;
}

@media (max-width: 991px) {
  .has-sidebar .ant-layout-content {
    margin-left: 0 !important;
  }
  
  .layout-dashboard-rtl.has-sidebar .ant-layout-content {
    margin-right: 0 !important;
  }
}
</style>